import Component from './abstract_component';
import $ from 'jquery';

class Navigation extends Component {
  constructor(toggleButton) {
    super();
    this.toggleButton = $(toggleButton);
    this.body = $('html, body');
  }

  _isReady() {
    return !!this.toggleButton.length;
  }

  _onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const toggleState = this.toggleButton.attr('aria-expanded');
    if (toggleState === 'true') {
      this._hide();
      this.body.off('click.menu');
    } else {
      this._show();
      this.body.on('click.menu', () => {
        this._hide();
      });
    }
  }

  _show(){
    this.body.addClass('has-menu-open').attr('data-menu', this.menuId);
    this.toggleButton.attr('aria-expanded', 'true');
    this.menu.addClass('is-visible').show();
  }

  _hide() {
    this.body.removeClass('has-menu-open').removeAttr('data-menu');
    this.toggleButton.attr('aria-expanded', 'false');
    this.menu.removeClass('is-visible').hide();
  }

  _run() {
    this.menuId = this.toggleButton.attr('aria-controls');
    this.menu = $(`#${this.menuId}`);
    this.toggleButton.on('click', this._onClick.bind(this));
    this.menu.on('click', (e) => {
      e.stopPropagation();
    })
  }
}

export default Navigation;
